<template>
    <vue-draggable-resizable
        ref="elem"
        class="preview"
        :w="toolbarWidth"
        :y="50"
    >
        <ul class="preview__list">
            <li v-for="screen in screens" :key="screen.name" class="preview__item">
                <button
                    class="preview__button"
                    :class="{ [STATE_CLASSES.ENABLED]: previewMode && screen.name === deviceMode.name }"
                    @click="toggle(screen)"
                >
                    <font-awesome-icon :icon="['fal', screen.icon]" />
                </button>
            </li>
        </ul>

        <button class="preview__close" @click="reset()">
            <font-awesome-icon :icon="['far', 'eye-slash']" />
        </button>
    </vue-draggable-resizable>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import VueDraggableResizable from 'vue-draggable-resizable';

import { getDevices } from '@/utils/devices';
import { SET_DEVICE_MODE, SET_PREVIEW_MODE } from '@/store/types/mutation-types';
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    components: { VueDraggableResizable },

    data() {
        return {
            screens: getDevices(),
            STATE_CLASSES,
            toolbarWidth: 50,
        };
    },

    computed: {
        ...mapState({
            deviceMode: state => state.page.deviceMode,
            previewMode: state => state.previewMode,
        }),
    },

    methods: {
        ...mapMutations([SET_DEVICE_MODE, SET_PREVIEW_MODE]),

        toggle(deviceMode) {
            this.setDeviceMode(deviceMode);
        },

        reset() {
            this.setPreviewMode(false);
        },
    },
};
</script>

<style lang="scss">
.preview {
    z-index: 1000 !important;
    height: auto !important;
    position: fixed !important;
    left: auto !important;
    right: 50px;
    background-color: white;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    box-shadow: 0 0 12px -5px rgba(black, 0.7);
    border-radius: 6px;
    border-top: 20px solid var(--previewToolbar-handleBackgroundColor);

    &:hover {
        cursor: move;
    }

    &:before,
    &:after {
        content: "";
        height: 1px;
        background-color: var(--previewToolbar-handleColor);
        position: absolute;
        margin: 0 auto;
    }

    &:before {
        width: 60%;
        top: -12px;
    }

    &:after {
        width: 60%;
        top: -8px;
    }

    &__list {
        display: flex;
        flex-direction: column;
        padding: 0;
        margin: 0;
        width: 100%;
        cursor: pointer;
    }

    &__item {
        list-style: none;
    }

    &__button {
        color: var(--previewToolbar-buttonColor);
        background-color: var(--previewToolbar-buttonBackgroundColor);
        border: none;
        padding: 0;
        font-size: 18px;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        &:hover {
            cursor: pointer;
            color: var(--previewToolbar-buttonHoverColor);
            background-color: var(--previewToolbar-buttonHoverBackgroundColor);
        }

        &.#{ $is-enabled } {
            color: var(--previewToolbar-selectedColor);
            background-color: var(--previewToolbar-selectedBackgroundColor);
        }
    }

    &__close {
        color: var(--previewToolbar-closeColor);
        background-color: var(--previewToolbar-closeBackgroundColor);
        font-weight: 300;
        width: 100%;
        height: 38px;
        line-height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        letter-spacing: 0.1em;
        font-size: 18px;
        font-weight: 700;
        border-radius: 0 0 6px 6px;

        &:hover {
            color: var(--previewToolbar-closeHoverColor);
            background-color: var(--previewToolbar-closeHoverBackgroundColor);
        }
    }
}
</style>
